import React, { useState } from 'react'
import { Container, Button } from 'reactstrap';
import {onboard_step_path, onboard_steps_path} from "../../../routes";
import {submitCall} from "../../shared/utils";
import Stepper from '../../stepper';
import ExtensionImage from '../../../images/extension-image.png'
import './step_five.scss'


const StepTwo = ({download_link}) => {
  const handleSubmit = (values, { setFieldError }) => {
    const { first_name, last_name, email, password } = values
    const submitValues = { first_name, last_name, password, email, id: 6 }
    setUserObject({
      first_name, last_name, email
    })

    submitCall(
      submitValues,
      'email',
      onboard_steps_path({format: 'json'}),
      setFieldError,
      pathWithParams
    )
  }

  const pathWithParams = () =>  onboard_step_path(6, {
      cp_k: license_key,
      cp_firstName: userObject.first_name,
      cp_lastName: userObject.last_name,
      cp_e: user_email,
      cp_ref: `trial.${company_name}`
  })

  return (
    <div className="page-onboarding">
      <section className="content">
        <Container>
          <div className="content-layout">
            <Stepper
              stepName="Chrome extension"
              customClass="page-onboarding-stepper"
              activeIndex={2}
              steprAmount={2}
            />
            <div className="page-onboarding-text">
            <div className="page-onboarding-title">Install the Chrome extension</div>
            <div className="page-onboarding-subtitle">
              Start improving your network connecting with the HubbleIQ Chrome extension.
              <div className="link">
                <a href={download_link} target="_blank">
                  Install
                </a>
              </div>
            </div>
            </div>
            <div className="page-onboarding-aside">
              <div className="page-block page-block_image">
                <img src={ExtensionImage} className="img-responsive" alt="extension" />
              </div>
            </div>
            <div className="page-onboarding-buttons">
            <Button
                className="button button-default-outlined"
                generaltype="default"
                onClick={() => window.location = onboard_step_path(1)}
              >
                Back
              </Button>
              <Button
                className="button button-default"
                generaltype="default"
                onClick={() => window.location = onboard_step_path(3)}
              >
                Next
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </div>           
  )
}

export default StepTwo
